/* -------------------------------------------

	Name:		Tobox
	Date:		2022/01/22

---------------------------------------------  */
/*global jQuery, document, Cookies, window, yall, setTimeout, ImageCompare */
var i = 0,
	img_lazy = document.querySelectorAll('img[data-src]:not(.dont)');
for (i = 0; i < img_lazy.length; i = i + 1) {
	img_lazy[i].classList.add('lazy');
}
document.addEventListener('DOMContentLoaded', function () {
	'use strict';
	yall({
		observeChanges: true,
		threshold: 500,
	});
});
jQuery(function () {
	'use strict';
	var $ = jQuery.noConflict(),
		html_tag = document.documentElement,
		footer_id = document.getElementById('footer'),
		footer_date = footer_id ? footer_id.querySelectorAll('.date') : [],
		intro_id = $(document.getElementById('intro')),
		email_tag = document.getElementsByClassName('email'),
		Default = {
			utils: {
				mails: function () {
					if (email_tag.length) {
						Array.from(email_tag)
							.filter(function (el) {
								return el.tagName.toLowerCase() !== 'input' && el.tagName.toLowerCase() !== 'div';
							})
							.forEach(function (el) {
								el.innerText = el.innerText.replace('//', '@').replace(/\//g, '.');
								if (el.tagName.toLowerCase() === 'a') {
									el.setAttribute('href', 'mailto:' + el.innerText);
								}
							});
					}
				},
				layout: function () {
					if ($('#announcement').length) {
						$('#top').addClass('has-announcement');
					}
				},
				date: function () {
					if (footer_date.length) {
						footer_date[0].innerText = new Date().getFullYear();
					}
				},
				mobile: function () {
					if (window.mobileCheck()) {
						html_tag.classList.add('mobile');
					} else {
						html_tag.classList.add('no-mobile');
					}
				},
				done: function () {
					var tag = document.createElement('script');
					tag.src = scripts_async_url;
					document.body.appendChild(tag);
				},
				miscellaneous: function () {
					function activateIntro() {
						console.log('intro');
						console.log(localStorage.getItem('adult'));
						$('#goFromSite').on('mousedown click tap touchstart', function (e) {
							e.preventDefault();
							console.log('from');
							window.location.href = 'https://www.google.com';
						});
						$('#goToSite').on('mousedown click tap touchstart', function (e) {
							e.preventDefault();
							console.log('to');
							html_tag.classList.add('over-18');
							localStorage.setItem('adult', 'yes');
							return false;
						});
						if (localStorage.getItem('adult') === 'yes') {
							console.log('adult');
							html_tag.classList.add('over-18');
							html_tag.classList.remove('less-18');
						} else {
							console.log('nope');
							html_tag.classList.add('less-18');
							html_tag.classList.remove('over-18');
						}
					}

					if ($('.show-france').length) {
						setTimeout(function () {
							$.getJSON('https://api.db-ip.com/v2/free/self', function (data) {
								if (data.countryName == 'France') {
									document.body.innerHTML = document.body.innerHTML.replace(/Cannabis/g, 'Herb');
									document.body.innerHTML = document.body.innerHTML.replace(/cannabis/g, 'herb');

									$('.show-france').removeClass('hidden');
									$('.hide-france').addClass('hidden');
									console.log('france');

									activateIntro();
								}
							});
						}, 50);
					}

					if (intro_id.length) {
						activateIntro();
					}

					var image_compare = document.getElementsByClassName('image-compare');
					if (image_compare.length) {
						Array.from(image_compare).forEach(function (el) {
							new ImageCompare(el).mount();
						});
					}
				},
			},
		};
	setTimeout(function () {
		Default.utils.mails();
		Default.utils.layout();
		Default.utils.date();
		Default.utils.miscellaneous();
		Default.utils.mobile();
		Default.utils.done();
	}, 0);
});

/*!*/
